<div>
  <strong *ngIf="data.title">{{data.title}}</strong>
  <br><br><span *ngIf="data.content">{{data.content}}</span><br><br>
  <button *ngIf="data.textButtonOne" id="buttonOne" mat-raised-button (click)="buttonOneClicked()">{{data.textButtonOne}}</button>
  <button *ngIf="data.textButtonTwo" id="buttonTwo" mat-raised-button (click)="buttonTwoClicked()" color="accent">{{data.textButtonTwo}}</button>
</div>
